import { SliderItem } from "@workspace/frontend-ui";

type Props = {
  items?: React.ReactNode[];
};

const CarouselItems: FC<Props> = ({ items }) => {
  if (!items) {
    return null;
  }

  return (
    <>
      {items.map((item, index) => (
        <SliderItem key={index} align="center">
          {item}
        </SliderItem>
      ))}
    </>
  );
};

export default CarouselItems;
